<template>
  <div class="tags"
       v-if="showTags">
    <!-- <ul>
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
                <router-link :to="item.path" class="tags-li-title">
                    {{item.title}}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
            </li>
        </ul> -->
    <el-tabs v-model="currentRouteName"
             type="card"
             v-if="showTabs"
              :closable="tagsList.length>1"
             @tab-click="handleClick"
             @tab-remove="removeTab">
      <el-tab-pane v-for="(item, key) in tagsList"
                   :key="key"
                   :label="item.title"
                   :name="item.name" @click="clickRight"></el-tab-pane>
    </el-tabs>
    <!-- 其他操作按钮 -->
    <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <el-button size="mini">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu size="small" slot="dropdown">
          <el-dropdown-item command="all">关闭当前</el-dropdown-item>
          <el-dropdown-item command="other">关闭其他</el-dropdown-item>
          <el-dropdown-item command="all">关闭所有</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentRoute: {
        path: ''
      },
      showTabs: true,
      currentRouteName: '',
      tagsList: sessionStorage.getItem('route') ? JSON.parse(sessionStorage.getItem('route')) : []
    }
  },
  computed: {
    showTags () {
      return this.tagsList.length > 0
    },
    addRouters () {
      return this.$store.getters.addRouters
    },
    routeTab() {
      return this.$store.getters.routeTab
    }
  },
  watch: {
    // 对router进行监听，每当访问router时，对tags的进行修改
    $route(newValue) {
      // console.log('更新', newValue);
      this.setTags(newValue)
    },
    routeTab: {
      handler(n, o) {
        this.tagsList = this.routeTab
      },
      deep: true
    },
    tagsList: {
      handler(newVal) {
        // console.log('更新tagsList', newVal);
        // this.showTabs = false
        // setTimeout(() => {
        //   this.showTabs = true
        // }, 100);
        // console.log(newVal)

        // this.router.push({
        //   path: newVal
        // })
      },
      deep: true
    },
    currentRoute: {
      handler (newVal) {
        // console.log(newVal)

        // this.router.push({
        //   path: newVal
        // })
      },
      deep: true
    },
    currentRouteName (newVal) {
      // let arr = this.tagsList.filter(item => item.name == this.currentRouteName)
      // if (arr.length > 0) {
      //   this.currentRoute = arr[0]
      // }
    }
  },
  created () {
    // console.log(this.addRouters)

    // 第一次进入页面时，修改tag的值
    this.setTags(this.$route)
  },
  methods: {
    isActive (path) {
      return path === this.$route.fullPath
    },
    // // 关闭单个标签
    // closeTags (index) {
    //   const delItem = this.tagsList.splice(index, 1)[0]
    //   const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1]
    //   if (item) {
    //     delItem.path === this.$route.fullPath && this.$router.push(item.path)
    //   } else {
    //     this.$router.push('/')
    //   }
    // },
    handleClick (tab) {
      // console.log(tab, this.currentRoute, this.currentRouteName)
      let arr = this.tagsList.filter(item => item.name == this.currentRouteName)
      if (arr.length > 0) {
        this.currentRoute = arr[0]
        this.$router.push({
          path: arr[0].path
        })
      }
    },
    setSession() {
      this.$store.dispatch('setRouteTab', this.tagsList)
      // sessionStorage.setItem('route', JSON.stringify(this.tagsList))
    },
    removeTab (targetName) {
      let removeIndex = 0
      this.tagsList.forEach((item, index) => {
        if (targetName === item.name) {
          removeIndex = index
        }
      })
      this.tagsList = this.tagsList.filter(item => item.name !== targetName)
      this.setSession()
      let currentIndex = removeIndex > 0 ? removeIndex - 1 : 0
      if (this.currentRouteName === targetName) {
        if (currentIndex > 0) {
          this.currentRoute = this.tagsList[currentIndex]
          this.$router.push({
            path: this.currentRoute.path
          })
        } else {
          if (this.tagsList.length > 0) {
            currentIndex = 0
            this.currentRoute = this.tagsList[currentIndex]
            this.$router.push({
              path: this.currentRoute.path
            })
          } else {
            this.$router.push({
              path: '/'
            })
          }
        }
      }
    },
    // 关闭全部标签
    closeAll () {
      this.tagsList = []
      this.$router.push('/')
    },
    // 关闭其他标签
    closeOther () {
      const curItem = this.tagsList.filter(item => {
        return item.path === this.$route.fullPath
      })
      this.tagsList = curItem
    },
    // 设置标签
    setTags (route) {
      let oneInfo = {
        title: route.meta.title,
        path: route.fullPath,
        name: route.name
      }
      this.currentRouteName = route.name
      this.currentRoute = oneInfo
      // let tagsList = sessionStorage.getItem('route') ? JSON.parse(sessionStorage.getItem('route')) : []
      const isExist = this.tagsList.some(item => {
        return item.name === route.name
      })
      !isExist && this.tagsList.push(oneInfo)
      this.setSession()
    },
    // 当关闭所有页面时隐藏
    handleTags (command) {
      command === 'other' ? this.closeOther() : this.closeAll()
    },
    clickRight (e) {
      console.log(123)
    }
  }
}

</script>

<style>
.tags {
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.tags-li {
  float: left;
  border-radius: 3px;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  height: 100%;
  line-height: 23px;
  margin: 0 5px;
  vertical-align: middle;
  color: rgba(255, 255, 255, 0.5);
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}

.tags-li-title {
  float: left;
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 5px;
  color: #666;
}

.tags-li.active {
  color: #fff;
  border: 1px solid #10b9d3;
  background-color: #10b9d3;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

.tags-close-box {
  position: fixed;
  right: 0;
  top: 50px;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  z-index: 10;
  display: none;
}
</style>
